var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55103 14.0001V10.0001C2.55103 9.73486 2.65853 9.4805 2.8499 9.29296C3.04126 9.10543 3.3008 9.00007 3.57143 9.00007H6.32347C6.52504 9.00012 6.7221 8.94166 6.8898 8.83207L11.1684 6.03607C11.3222 5.9355 11.501 5.87778 11.6857 5.86907C11.8704 5.86037 12.054 5.90102 12.217 5.98667C12.3799 6.07232 12.5161 6.19975 12.6109 6.35535C12.7056 6.51095 12.7555 6.68886 12.7551 6.87007V17.1301C12.7551 17.3111 12.705 17.4888 12.6101 17.6441C12.5152 17.7994 12.379 17.9265 12.2161 18.0119C12.0532 18.0974 11.8697 18.1378 11.6852 18.129C11.5007 18.1203 11.322 18.0626 11.1684 17.9621L6.8898 15.1671C6.72199 15.0578 6.52493 14.9997 6.32347 15.0001H3.57143C3.3008 15.0001 3.04126 14.8947 2.8499 14.7072C2.65853 14.5196 2.55103 14.2653 2.55103 14.0001V14.0001Z",
    stroke: "#151618",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3469 7.5C17.3469 7.5 18.8775 9 18.8775 11.5C18.8775 14 17.3469 15.5 17.3469 15.5M20.4081 4.5C20.4081 4.5 22.9592 7 22.9592 11.5C22.9592 16 20.4081 18.5 20.4081 18.5",
    stroke: "#151618",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/sound_icon.e07a04a21cd0f8fc6238527d1707b8d2.svg";
export { ForwardRef as ReactComponent };